var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChartDonutDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 104C208 161.438 161.438 208 104 208C46.5624 208 0 161.438 0 104C0 46.5624 46.5624 0 104 0C161.438 0 208 46.5624 208 104ZM30.2952 104C30.2952 144.706 63.294 177.705 104 177.705C144.706 177.705 177.705 144.706 177.705 104C177.705 63.294 144.706 30.2952 104 30.2952C63.294 30.2952 30.2952 63.294 30.2952 104Z",
    fill: "#424850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartDonutDarkTheme);
export default __webpack_public_path__ + "static/media/empty-chart-donut-dark-theme.b29af52ba196d749c0e75cb4b396af42.svg";
export { ForwardRef as ReactComponent };